export class ProposalDeliverable {
	public uuid: string;
	public title: number;
	public quantity: number;
	public rate: number;
	public temp_id: number;

	constructor(input?: any) {
		if (input) {
			Object.assign(this, input);
		}
		this.temp_id = new Date().valueOf();
	}

	public get cost() {
		return this.quantity * this.rate;
	}

}
